import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@mui/material";
import NewPrintBtn from "../utilities/NewPrintBtn";
import styles from "../../assets/css/modules/shipmentModal.module.css";

// Premium Success Icon
const SuccessIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

export default function ExcelUploadModal({ open, setOpen, id, setError }) {
  const { t } = useTranslation("uploadExcel");
  const { language } = useTranslation().i18n;

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <div className={styles.modalCard} dir={language === "ar" ? "rtl" : "ltr"}>
        {/* Close button */}
        <button 
          className={styles.closeBtn} 
          onClick={() => setOpen(false)}
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        {/* Success circular badge */}
        <div className={styles.successBadge}>
          <SuccessIcon />
        </div>

        {/* Title */}
        <div className={styles.modalTitle}>{t("modal.title")}</div>

        {/* ID Code highlight box */}
        <div className={styles.awbBox}>
          <span className={styles.awbLabel}>{t("modal.description")}</span>
          <span className={styles.awbValue}>{id}</span>
        </div>

        {/* Action button */}
        <div className={styles.buttonsContainer}>
          <NewPrintBtn data={id} print="pickup" setError={setError} />
        </div>
      </div>
    </Modal>
  );
}
